import { VideoStore } from './type';
import mutations from './mutation';

const state: VideoStore = {
  isEnd: false
};

export default {
  namespaced: true,
  state,
  mutations
};
